export const MIN_DATE = '1900-01-01T00:00:00';